import * as actions from './Actions.js';

import BotaoImprimir from 'portaltransparencia-common/components/BotaoImprimir.react.js';
import CabecalhoEntidade from '../entidades/CabecalhoEntidade.react.js';
import Component from 'react-pure-render/component';
import Helmet from 'react-helmet';
import { ObraDetalheEmpenho } from './ObraDetalheEmpenho.react.js';
import ObraDetalheInformacao from './ObraDetalheInformacao.react.js';
import ObraDetalheMedicao from './ObraDetalheMedicao.react.js';
import ObraDetalhePlanilha from './ObraDetalhePlanilha.react.js';
import { PARAM_PLANILHASOBRAS } from 'portaltransparencia-common/parametros/ParametrosPortalTransparencia';
import PageHeader from '../components/PageHeader.react.js';
import Panel from 'portaltransparencia-common/components/Panel.react.js';
import ParametroService from '../parametros/ParametroService.js';
import PropTypes from 'prop-types';
import React from 'react';
import Tab from 'portaltransparencia-common/components/Tab.react.js';
import Tabs from 'portaltransparencia-common/components/Tabs.react.js';
import { connect } from 'react-redux';
import { downloadArquivo } from '../arquivo/Actions.js';
import { getValueFromUrlSearchParams } from 'portaltransparencia-common/libs/URLUtils';
import ObraOrdemServicoArquivo from './ObraOrdemServicoArquivo.react.js';
import ObraFonteRecurso from './ObraFonteRecurso.react.js';
import {
  findEmpenhoLiquidacoesDocumentosMultiplos,
  findEmpenhoLiquidacoesMultipla,
  resetLiquidacoesDocumentosMultiplos,
  resetLiquidacoesMultipla
} from '../empenhos/Actions.js';
import EmpenhoDetalheLiquidacoes from '../empenhos/FormDetalheLiquidacao.react.js';
import EmpenhoDetalheLiquidacoesDocumentos from '../empenhos/FormDetalheLiquidacaoDocumentos.react.js';

export class ObraDetalhe extends Component {
  static propTypes = {
    obra: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    findObra: PropTypes.func.isRequired,
    medicoes: PropTypes.object.isRequired,
    empenhos: PropTypes.object.isRequired,
    findMedicoes: PropTypes.func.isRequired,
    downloadArquivo: PropTypes.func.isRequired,
    planilhas: PropTypes.object.isRequired,
    findPlanilhas: PropTypes.func.isRequired,
    findEmpenhos: PropTypes.func.isRequired,
    imagens: PropTypes.object.isRequired,
    findImagens: PropTypes.func.isRequired,
    paramPlanilhas: PropTypes.string,
    history: PropTypes.object,
    configGeral: PropTypes.object
  };

  componentDidMount() {
    const {
      findObra,
      location,
      findMedicoes,
      findPlanilhas,
      findEmpenhos,
      findOrdemArquivos,
      findEmpenhoLiquidacoesMultipla,
      resetLiquidacoesMultipla,
      findEmpenhoLiquidacoesDocumentosMultiplos,
      resetLiquidacoesDocumentosMultiplos
    } = this.props;

    const entidade = getValueFromUrlSearchParams(location, 'entidade');
    const exercicioObra = getValueFromUrlSearchParams(
      location,
      'exercicioObra'
    );
    const idOrdemServico = getValueFromUrlSearchParams(
      location,
      'idOrdemServico'
    );

    resetLiquidacoesMultipla();
    resetLiquidacoesDocumentosMultiplos();
    findObra(entidade, exercicioObra, idOrdemServico);
    findMedicoes(entidade, exercicioObra, idOrdemServico);
    findOrdemArquivos(entidade, exercicioObra, idOrdemServico);
    findPlanilhas(entidade, exercicioObra, idOrdemServico);
    findEmpenhos(entidade, exercicioObra, idOrdemServico).then(({ value }) => {
      value.map(empenho => {
        const filtro = `?search=id.entidade==${entidade}&entidade=${entidade}&exercicio=${exercicioObra}&empenho=${empenho.numeroEmpenho}`;
        findEmpenhoLiquidacoesMultipla(filtro);
        findEmpenhoLiquidacoesDocumentosMultiplos(filtro);
      });
    });
  }
  buildFilterEmpenho(obra) {
    const entidade = obra.get('entidade');
    const exercicioObra = obra.get('exercicio');
    const idOrdemObra = obra.get('idOrdembuildFilterEmpenhoServico');
    if (!entidade) return '';
    const filter = `?search=id.entidade==${entidade} and exercicioObra==${exercicioObra} and idOrdemObra==${idOrdemObra}`;
    return filter;
  }

  getValorEmpenhado = empenhos => {
    let valorAnulacoes = 0;
    let valorEstornoAnulacoes = 0;
    let valorEmpenhado = 0;

    if (empenhos) {
      empenhos.map(empenho => {
        valorAnulacoes = empenho.get('valorAnulacoes')
          ? empenho.get('valorAnulacoes')
          : 0;
        valorEstornoAnulacoes = empenho.get('valorEstornoAnulacoes')
          ? empenho.get('valorEstornoAnulacoes')
          : 0;
        valorEmpenhado +=
          empenho.get('valor') - (valorAnulacoes - valorEstornoAnulacoes);
      });
    }

    return valorEmpenhado;
  };

  render() {
    const {
      obra,
      medicoes,
      downloadArquivo,
      planilhas,
      location,
      findImagens,
      imagens,
      paramPlanilhas,
      empenhos,
      history,
      configGeral,
      ordemArquivos
    } = this.props;
    return (
      <div>
        <Helmet title={`Obras Públicas - ${obra.get('descricaoBem')}`} />

        <PageHeader
          location={location}
          textoDetalhe={`Obras Públicas - ${obra.get('descricaoBem')}`}
        />

        <BotaoImprimir />

        <CabecalhoEntidade />

        <ObraDetalheInformacao
          entidade={getValueFromUrlSearchParams(location, 'entidade')}
          exercicioObra={getValueFromUrlSearchParams(location, 'exercicioObra')}
          idOrdemServico={getValueFromUrlSearchParams(
            location,
            'idOrdemServico'
          )}
          valorEmpenhado={this.getValorEmpenhado(empenhos)}
          isIntegradoOxy={configGeral.get('isIntegradoOxy')}
        />

        <Panel expansible={false} isTable tableResponsive>
          <Tabs scrollVisibled>
            <Tab title="Medições" active>
              <ObraDetalheMedicao
                medicoes={medicoes}
                onDownload={downloadArquivo}
                location={location}
                findImagens={findImagens}
                imagens={imagens}
              />
            </Tab>

            <Tab title="Empenhos">
              <h4 className="mt-xs mb-xs center">
                <b>Empenhos</b>
              </h4>
              <ObraDetalheEmpenho
                empenhos={empenhos}
                entidade={obra.get('entidade')}
                location={location}
                history={history}
              />
            </Tab>
            <Tab title="Planilhas" hide={paramPlanilhas !== 'S'}>
              <ObraDetalhePlanilha
                planilhas={planilhas}
                onDownload={downloadArquivo}
              />
            </Tab>
            <Tab title="Anexos/Cronogramas">
              <ObraOrdemServicoArquivo ordemArquivos={ordemArquivos} />
            </Tab>
            <Tab title="Fontes recurso">
              <h4 className="mt-xs mb-xs center">
                <b>Fontes recurso</b>
              </h4>
              <ObraFonteRecurso empenhos={empenhos} />
            </Tab>

            <Tab title="Liquidações">
              <EmpenhoDetalheLiquidacoes exibeEmpenho={true} />
            </Tab>

            <Tab title="Documentos Liquidação">
              <EmpenhoDetalheLiquidacoesDocumentos exibeEmpenho={true} />
            </Tab>
          </Tabs>
        </Panel>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    obra: state.obra.get('obra'),
    medicoes: state.obra.get('medicoes'),
    planilhas: state.obra.get('planilhas'),
    ordemArquivos: state.obra.get('ordemArquivos'),
    imagens: state.obra.get('imagens'),
    empenhos: state.obra.get('empenhos'),
    configGeral: state.entidade.get('configuracoesGerais'),
    paramPlanilhas: ParametroService.getValorParametro(
      state,
      PARAM_PLANILHASOBRAS
    )
  };
}

const allActions = {
  ...actions,
  findEmpenhoLiquidacoesMultipla,
  resetLiquidacoesMultipla,
  findEmpenhoLiquidacoesDocumentosMultiplos,
  resetLiquidacoesDocumentosMultiplos,
  downloadArquivo
};

export default connect(mapStateToProps, allActions)(ObraDetalhe);
